import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import { Layout, Button, Input, Select } from "element-react";
import Paging from 'components/Paging'
import NoDataPicture from 'components/NoDataPicture'
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import PagingContent from 'components/PagingContent'

require("./index.scss");

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      navNum: '',
      params: {
        size: 8,
        productTypeId: 1,
        title: ''
      },
      obj: {
        size: 8,
        productTypeId: 1,
        title: ''
      },
      productTypeId: 1,
      product2: "",
      army: [],
      title: ''
    };
  }

  componentDidMount = () => {
    this.getTypeList()
  }

  // 获取产品分类
  getTypeList() {
    let params = {
      productTypeId: this.state.productTypeId,
    };
    return Http.get(Request.getProductType(), params, obj => {
      if (obj && obj.code == 200) {
        this.setState({
          army: obj.data
        })
      }
    });
  }

  // 点击搜索
  getList = () => {
    this.setState({
      params: this.state.obj
    })

  }

  onChange(key, value) {
    this.setState({
      obj: Object.assign({}, this.state.obj, { [key]: value })
    });
  }

  renderList(data) {
    if (data == '' || !data.records) {
      return '';
    }
    let records = data.records;
    return (
      <div className="container clear">
        {records.length != 0 ? records.map((item) => {
          return (
            <ul className='card_ul'>
              <li className='card'>
                <Link to={"/entrance/preferentialProductsDetail?" + item.id}>
                  {
                    item.photoUrl == '' ? <NoDataPicture /> :
                      <img src={item.photoUrl} className="image" />
                  }
                  <h3>{item.title}</h3>
                  <div className="describe" >

                    <p title={item.introduction != '' ? item.introduction : '暂无描述'}><span>{item.introduction != '' ? item.introduction : '暂无描述'}</span></p>
                    <div className="bottom">
                      <div className="cost">￥{item.price}</div>
                      <Button type="text" className="button">立即报名</Button>
                    </div>
                  </div>
                </Link>
              </li>
            </ul>

          )
        })
          : ''
        }
      </div>
    );
  }


  render() {
    let { army, param } = this.state;
    return (
      <div className="box">
        <div className="container clear">
          <div className="query" style={{ margin: '20px 0 10px' }}>
            <span className="search_lable">产品名称</span>
            {/* <div className="search_select" style={{ width: '170px' }}>
              <Select onChange={this.onChange.bind(this, 'productTypeId')}>
                {
                  army && army.map(el => {
                    return <Select.Option key={
                      el.id
                    }
                      label={
                        el.name
                      }
                      value={
                        el.id
                      }
                    />
                  })
                }
              </Select>
            </div> */}

            <div style={{ display: 'inline-block' }}>
              <div className="search_select margin_r10" style={{ width: '230px' }}>
                <Input type="text" value={this.state.obj.title} onChange={this.onChange.bind(this, 'title')} autoComplete="off" placeholder="输入产品名称查询" />
              </div>
              <Button className="search_btn" style={{ width: '72px' }} onClick={() => this.getList()}>搜索</Button>
            </div>

          </div>
        </div>
        <PagingContent pageSizes={[8, 16, 24, 32, 40]} requestUrl={Request.soldigetWelfareServiceLister()} renderList={this.renderList} params={this.state.params} />
      </div>

    );
  }
}
